export function organizationName(title) {
  return title.replace(
    /(\bElementary School|Elementary-Middle School|Middle School|Middle-High School|High School|Elementary-Middle-High School)/g,
    ''
  )
  // return title.replace(
  //   /(\bElementary School|Elementary-Middle School|Middle School|Middle-High School|High School|Elementary-Middle-High School|\w*[-]\w*\b)(?!.*\1)/g,
  //   ''
  // )
}

export function organizationLevel(title) {
  return (
    title.match(
      /(\bElementary School|Elementary-Middle School|Middle School|Middle-High School|High School|Elementary-Middle-High School)/g
    ) || []
  ).join('')
  // return (
  //   title.match(
  //     /(\bElementary School|Elementary-Middle School|Middle School|Middle-High School|High School|Elementary-Middle-High School|\w*[-]\w*\b)(?!.*\1)/g
  //   ) || []
  // ).join('')
}

// TODO: Move to picker, not generic enough, specific to the pickers logic/ui
export function asList(organization) {
  let categories = ['Elementary', 'Middle', 'High']
  let sorted = []
  for (const c of categories) {
    sorted.push({
      title: c,
      itemsSorted: sortOrgsByLevel(organization, c),
    })
  }
  return sorted
}

export function sortOrgsByLevel(orgs, level) {
  return orgs
    .filter(o => {
      if (o.educationLevels.includes(level)) {
        return o
      }
    })
    .sort((a, b) => {
      if (a.label < b.label) return -1
      if (a.label > b.label) return 1
      return 0
    })
}
